import React from "react";
import { Routes, Route } from "react-router-dom";
import { SolutionList } from "./List";
import { SolutionDetail } from "./Detail";

export const SolutionPage = () => {
  return (
    <Routes>
      <Route path="/" element={<SolutionList />} />
      <Route path="/:type" element={<SolutionDetail />} />
    </Routes>
  );
};
